import Grid from "@mui/material/Grid";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

function Footer() {
  return (
    <VuiBox
      component="footer"
      py={4}
      sx={({ breakpoints }) => ({
        maxWidth: "450px",
        [breakpoints.down("xl")]: {
          maxWidth: "400px",
        },
      })}
    >
      <Grid container justifyContent="center">
        <Grid item xs={12} sx={{ textAlign: "center", mb: 1 }}>
          <VuiTypography
            variant="button"
            sx={{ textAlign: "center", fontWeight: "400 !important", opacity: 0.7 }}
            color="text"
          >
            &copy; 2026 Intent Web &bull; Powered by Intent Network
          </VuiTypography>
        </Grid>
        <Grid item xs={10}>
          <VuiBox display="flex" justifyContent="center" flexWrap="wrap">
            <VuiBox mr="20px">
              <VuiTypography component="a" href="https://web.int.yt" target="_blank" rel="noreferrer" variant="body2" color="text">
                Documentation
              </VuiTypography>
            </VuiBox>
            <VuiBox mr="20px">
              <VuiTypography component="a" href="https://dns.int.yt" target="_blank" rel="noreferrer" variant="body2" color="text">
                DNS
              </VuiTypography>
            </VuiBox>
            <VuiBox>
              <VuiTypography component="a" href="https://int.yt" target="_blank" rel="noreferrer" variant="body2" color="text">
                Main Portal
              </VuiTypography>
            </VuiBox>
          </VuiBox>
        </Grid>
      </Grid>
    </VuiBox>
  );
}

export default Footer;
